<div
  class="w-full flex justify-center card-page-container pointer-events-auto size-{{
    heightProfile()
  }}"
>
  <div
    class="card bg-base-100 shadow-xl page-card pb-4"
    [class.my-4]="!isEmbeddedInModal()"
  >
    <div class="card-body h-full">
      <h1 class="type-page-title grid grid-cols-[1fr_auto_1fr] gap-4 min-h-8">
        <div class="justify-self-start">
          <ng-content select="[pageactions]"></ng-content>
        </div>

        <div class="text-xl">
          <ng-content select="[header]"></ng-content>
        </div>

        <div class="justify-self-end text-sm font-normal">
          <ng-content select="[pageactionssecondary]"></ng-content>
        </div>
      </h1>

      <div class="card-content h-full">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
